import {
  Component,
  forwardRef,
  Inject,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from '@angular/core';

import {
  BlockUI,
  NgBlockUI
} from 'ng-block-ui';

import { HaynesProService }           from '../haynes-pro.service';
import { HaynesProSubGroupModel }     from '../typings/haynes-pro.sub-group';
import { HaynesProWarningLightModel } from '../typings/haynes-pro.warning-light';
import { MessagesService }            from '../../messages/messages.service';
import { VehicleModel }               from '../../vehicles/models/vehicle';

@Component({
  selector   : 'wor-haynes-pro-diagnostic-tool-warning-lights',
  template: require('./haynes-pro.diagnostic-tool.warning-lights.component.html')
})
export class HaynesProDiagnosticToolWarningLightsComponent implements OnChanges, OnInit {

  @BlockUI('haynesProWarningLightsBlock') block : NgBlockUI;

  @Input() isActive  : boolean;
  @Input() subGroups : Array<HaynesProSubGroupModel>;
  @Input() vehicle   : VehicleModel;

  subGroup : HaynesProSubGroupModel;
  warnings : Array<HaynesProWarningLightModel> = [];

  constructor (
    @Inject(forwardRef(() => HaynesProService)) private haynesProService : HaynesProService,
    private messagesService  : MessagesService
  ) {}

  ngOnChanges ( changes : SimpleChanges ) : void {
    if ( changes.isActive && !changes.isActive.isFirstChange() && changes.isActive.currentValue ) {
      const subGroup = this.subGroup
        ? this.subGroup
        : this.subGroups[0];

      subGroup.selected = true;
    }
  }

  ngOnInit () : void {
    if (this.isActive) {

      this.subGroups[0].selected = true;

      };

    }

  handleSubGroupSelection ( subGroup : HaynesProSubGroupModel ) : void {
    this.block.start();

    this.subGroup = subGroup;
    this.warnings = [];

    this.haynesProService.getWarningLights(this.vehicle)
    .then(( warnings : Array<HaynesProWarningLightModel> ) => {
      this.warnings = warnings;

      if ( !this.isActive ) {


        this.haynesProService.updateSubscriptionStatus(true);


      }
    })
    .catch(( err ) => {
      this.messagesService.error(err);
    })
    .finally(() => {
      this.block.stop();
    });
  }

}